// extracted by mini-css-extract-plugin
export default {"container":"OEvbFIXnqQRCNfLMuy8R","wrapper":"SO9_8KbMSHYZwq3ITACE","signatureText":"wijOHNi0JjU40svGb8gf","info":"htlvJGI49V0ONJOQG1XV"};